// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks-module--social-links--3cuOO","shareCount":"SocialLinks-module--share-count--2IJV6"};